import { Grid } from '@material-ui/core';
import { KeyboardBackspace } from '@material-ui/icons';
import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@components/Button';
import { Spacer } from '@components/Spacer';

import useStyles from './styles';

type Text = string | React.ReactNode;

export interface ServerErrorLayoutProps {
  backPath?: string | false;
  backText?: Text;
  secondaryBackPath?: string;
  secondaryBackText?: Text;
  headerText: Text;
  image: React.ReactNode;
  subHeaderText: Text;
}

export const ServerErrorLayout: React.FC<ServerErrorLayoutProps> = ({
  image,
  backPath,
  backText,
  secondaryBackPath,
  secondaryBackText,
  headerText,
  subHeaderText,
}) => {
  const classes = useStyles();

  const msg = (
    <>
      <Spacer height={50} />
      <div className={classes.message}>
        <h1>{headerText}</h1>
        <div>{subHeaderText}</div>
      </div>
    </>
  );

  return (
    <Grid container justify="center">
      <Grid item xl={2} />

      <Grid item xs={12} md={10} xl={8}>
        <Grid container>
          <Grid item xs={12} xl={8}>
            {image}
          </Grid>

          <Grid item xs={12} md={5} xl={8}>
            {msg}
          </Grid>

          {(backPath || secondaryBackPath) && (
            <Grid item xs={12} xl={8} className={classes.back}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                {backPath && (
                  <Button
                    component={Link}
                    to={backPath}
                    startIcon={<KeyboardBackspace color="secondary" />}
                  >
                    {backText}
                  </Button>
                )}
                {secondaryBackPath && (
                  <Button
                    component={Link}
                    to={secondaryBackPath}
                    startIcon={<KeyboardBackspace color="secondary" />}
                  >
                    {secondaryBackText}
                  </Button>
                )}
              </div>
            </Grid>
          )}

          <Grid item xs={12} xl={8}>
            <Spacer height={50} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
